(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-app-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function num(el, name, fallback) {
      var v = parseFloat(getComputedStyle(el).getPropertyValue(name));
      return isNaN(v) ? fallback : v;
    }

    function init(root) {
      if (!root || root.dataset.tcBound === '1') return;
      root.dataset.tcBound = '1';

      var slides = Array.prototype.slice.call(root.querySelectorAll('.tc-sc__slide'));
      var n = slides.length;
      if (!n) return;

      var start = parseInt(root.dataset.start, 10) || 0;
      var active = ((start % n) + n) % n;

      function layout() {
        var spacing = num(root, '--tc-sc-spacing', 380);
        var side = num(root, '--tc-sc-side', 0.85);
        var dy = num(root, '--tc-sc-side-y', 0);
        var visible = num(root, '--tc-sc-visible', 1);

        slides.forEach(function (el, i) {
          var off = i - active;
          // Defilement circulaire : on prend le chemin le plus court
          if (off > n / 2) off -= n;
          if (off < -n / 2) off += n;
          var a = Math.abs(off);
          var scale = a === 0 ? 1 : Math.pow(side, a);
          var hidden = a > visible;

          el.style.transform =
            'translate(-50%, -50%) translate(' + off * spacing + 'px, ' + (a ? dy * a : 0) + 'px) scale(' + scale + ')';
          el.style.zIndex = String(100 - a);
          el.style.opacity = hidden ? '0' : '1';
          el.style.pointerEvents = hidden ? 'none' : 'auto';
          el.classList.toggle('is-active', a === 0);
          el.setAttribute('aria-hidden', a === 0 ? 'false' : 'true');
        });
      }

      function go(i) {
        active = ((i % n) + n) % n;
        layout();
      }

      var prev = root.querySelector('[data-tc-sc-prev]');
      var next = root.querySelector('[data-tc-sc-next]');
      if (prev) prev.addEventListener('click', function () { go(active - 1); restart(); });
      if (next) next.addEventListener('click', function () { go(active + 1); restart(); });

      // Clic sur une capture laterale : la ramener au centre
      slides.forEach(function (el, i) {
        el.addEventListener('click', function () {
          if (i !== active && !moved) { go(i); restart(); }
        });
      });

      // Glissement au doigt / a la souris
      var x0 = null, moved = false;
      root.addEventListener('pointerdown', function (e) { x0 = e.clientX; moved = false; });
      root.addEventListener('pointermove', function (e) {
        if (x0 !== null && Math.abs(e.clientX - x0) > 8) moved = true;
      });
      root.addEventListener('pointerup', function (e) {
        if (x0 === null) return;
        var dx = e.clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) { go(active + (dx < 0 ? 1 : -1)); restart(); }
        setTimeout(function () { moved = false; }, 0);
      });
      root.addEventListener('pointercancel', function () { x0 = null; });

      // Clavier
      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { go(active - 1); restart(); }
        if (e.key === 'ArrowRight') { go(active + 1); restart(); }
      });

      // Lecture automatique (desactivee si l'utilisateur reduit les animations)
      var timer = null;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var auto = root.dataset.autoplay === 'true' && !reduce && n > 1;
      var interval = parseInt(root.dataset.interval, 10) || 4000;
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function play() { if (auto && !timer) timer = setInterval(function () { go(active + 1); }, interval); }
      function restart() { stop(); play(); }
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', play);

      var raf = null;
      window.addEventListener('resize', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(layout);
      });

      layout();
      play();
    }

    function boot(scope) {
      (scope || document).querySelectorAll('[data-tc-sc]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(); });
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-tc-sc]');
      if (!root) return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('.tc-sc__slide'));
      var i = slides.indexOf(e.target);
      if (i >= 0) {
        root.dataset.tcBound = '';
        root.dataset.start = String(i);
        init(root);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-app"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function detectOS() {
      var ua = navigator.userAgent || '';
      var plat = (navigator.userAgentData && navigator.userAgentData.platform) || navigator.platform || '';

      // iPadOS se declare comme MacIntel : on le distingue par le tactile
      if (/iPhone|iPod/.test(ua)) return 'ios';
      if (/iPad/.test(ua) || (plat === 'MacIntel' && navigator.maxTouchPoints > 1)) return 'ipados';
      if (/Android/.test(ua)) return 'android';
      if (/Mac/i.test(plat) || /Mac OS X/.test(ua)) return 'macos';
      if (/Win/i.test(plat) || /Windows/.test(ua)) return 'windows';
      if (/Linux/i.test(plat)) return 'linux';
      return '';
    }

    function apply(root) {
      var os = detectOS();
      if (!os) return;

      var match = root.querySelector('[data-os="' + os + '"]');

      // iPadOS retombe sur iOS si aucun bouton dedie n'est defini
      if (!match && os === 'ipados') match = root.querySelector('[data-os="ios"]');

      if (!match) return;

      root.querySelectorAll('[data-os]').forEach(function (el) { el.hidden = true; });
      match.hidden = false;

      var fallback = root.querySelector('[data-os-fallback]');
      if (fallback) fallback.hidden = true;
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-tc-app]').forEach(apply);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }

    // Editeur de theme
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-bento"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(scope) {
      (scope || document).querySelectorAll('.tc-bento__toggle').forEach(function (btn) {
        if (btn.dataset.tcBound === '1') return;
        btn.dataset.tcBound = '1';

        btn.addEventListener('click', function () {
          var panel = document.getElementById(btn.getAttribute('aria-controls'));
          if (!panel) return;
          var open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          panel.hidden = open;
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { bind(); });
    } else {
      bind();
    }

    document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-scales"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(scope) {
      (scope || document).querySelectorAll('[data-tc-modal-open]').forEach(function (btn) {
        if (btn.dataset.tcBound === '1') return;
        btn.dataset.tcBound = '1';

        btn.addEventListener('click', function () {
          var dlg = document.getElementById(btn.getAttribute('data-tc-modal-open'));
          if (!dlg) return;
          if (typeof dlg.showModal === 'function') {
            dlg.showModal();
          } else {
            dlg.setAttribute('open', '');
          }
          document.body.style.overflow = 'hidden';
        });
      });

      (scope || document).querySelectorAll('.tc-modal').forEach(function (dlg) {
        if (dlg.dataset.tcBound === '1') return;
        dlg.dataset.tcBound = '1';

        var close = function () {
          if (typeof dlg.close === 'function') {
            dlg.close();
          } else {
            dlg.removeAttribute('open');
          }
        };

        var btn = dlg.querySelector('[data-tc-modal-close]');
        if (btn) btn.addEventListener('click', close);

        // Clic sur le fond : la zone du dialog hors de la boite
        dlg.addEventListener('click', function (e) {
          if (e.target === dlg) close();
        });

        dlg.addEventListener('close', function () {
          document.body.style.overflow = '';
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { bind(); });
    } else {
      bind();
    }

    document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
